import React, { useState } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";

const testData = [
  { userId: 1, name: "User 1", email: "user1@example.com" },
  { userId: 2, name: "User 2", email: "user2@example.com" },
  { userId: 3, name: "User 3", email: "user3@example.com" }
];

const DetailRow = ({ dataItem }) => (
  <tr>
    <td colSpan={4} style={{ background: "#f0f0f0", padding: 20 }}>
      Detail for {dataItem.name} ({dataItem.email})
    </td>
  </tr>
);

export default function AssignedUsersGridSingleExpandExample() {
  const [expandedRowId, setExpandedRowId] = useState(null);

  const handleExpandClick = (dataItem) => {
    setExpandedRowId(expandedRowId === dataItem.userId ? null : dataItem.userId);
  };

  return (
    <table className="k-grid k-widget" style={{ width: "100%" }}>
      <thead className="k-grid-header">
        <tr>
          <th style={{ width: 50 }}></th>
          <th>User ID</th>
          <th>Name</th>
          <th>Email</th>
        </tr>
      </thead>
      <tbody className="k-grid-content">
        {testData.map((item) => (
          <React.Fragment key={item.userId}>
            <tr>
              <td style={{ textAlign: "center" }}>
                <button
                  onClick={() => handleExpandClick(item)}
                  style={{ cursor: "pointer" }}
                  aria-label={expandedRowId === item.userId ? "Collapse" : "Expand"}
                >
                  {expandedRowId === item.userId ? "-" : "+"}
                </button>
              </td>
              <td>{item.userId}</td>
              <td>{item.name}</td>
              <td>{item.email}</td>
            </tr>
            {expandedRowId === item.userId && <DetailRow dataItem={item} />}
          </React.Fragment>
        ))}
      </tbody>
    </table>
  );
}
